import { render } from "./AllSdgs.vue?vue&type=template&id=5c22cc4e&scoped=true"
import script from "./AllSdgs.vue?vue&type=script&lang=js"
export * from "./AllSdgs.vue?vue&type=script&lang=js"

import "./AllSdgs.vue?vue&type=style&index=0&id=5c22cc4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c22cc4e"]])

export default __exports__